import { render, staticRenderFns } from "./WarningMethod.vue?vue&type=template&id=649b09ef&scoped=true"
import script from "./WarningMethod.vue?vue&type=script&lang=js"
export * from "./WarningMethod.vue?vue&type=script&lang=js"
import style0 from "./WarningMethod.vue?vue&type=style&index=0&id=649b09ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649b09ef",
  null
  
)

export default component.exports